const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ constants
const TYPE_OF_ROADS = require('constants/typeOfRoadsList');
const KEYS_NAMES = {
    v1: {
        streetType: 'tipoVia',
        street: 'calleBien',
        streetNumber: 'numeroCalle',
        streetBlock: 'bloque',
        streetStair: 'escalera',
        streetPlant: 'planta',
        streetletter: 'letra',
        postalCode: 'codigoPostal',
        addressOthers: 'addressOthers',
        provinceName: 'provincia',
        populationName: 'poblacion'
    },
    v2: {
        streetType: 'streetType',
        street: 'street',
        streetNumber: 'streetNumber',
        streetBlock: 'streetBlock',
        streetStair: 'streetStair',
        streetPlant: 'streetPlant',
        streetletter: 'streetletter',
        postalCode: 'postalCode',
        addressOthers: 'addressOthers',
        provinceName: 'provinceName',
        populationName: 'populationName'
    }
};
const TEXTS = {
    bloque: formatText('mortgageRequestAddressFormat-block'),
    escalera: formatText('mortgageRequestAddressFormat-staircase'),
    planta: formatText('mortgageRequestAddressFormat-floor'),
    letra: formatText('mortgageRequestAddressFormat-letter'),
    streetBlock: formatText('mortgageRequestAddressFormat-block'),
    streetStair: formatText('mortgageRequestAddressFormat-staircase'),
    streetPlant: formatText('mortgageRequestAddressFormat-floor'),
    streetletter: formatText('mortgageRequestAddressFormat-letter')
};

class MortgageRequestFormattedAddress extends React.Component {

    getFormattedValue(key) {
        const { immEstate } = this.props;
        let text = '';

        if (immEstate.get(key)) {
            if (TEXTS[key]) {
                text = `, ${TEXTS[key]}: ${immEstate.get(key)}`;
            }
            else {
                text = `${immEstate.get(key)}`;
            }
        }

        return text;
    }

    render() {
        const { immEstate, className, compact, v1 } = this.props;

        const KEYS = v1 ? KEYS_NAMES['v1'] : KEYS_NAMES['v2'];

        const typeOfRoads = v1 ? immEstate.get(KEYS.streetType) : TYPE_OF_ROADS[immEstate.get(KEYS.streetType)] || '';

        const street = this.getFormattedValue(KEYS.street);
        const streetNumber = this.getFormattedValue(KEYS.streetNumber);

        const streetBlock = this.getFormattedValue(KEYS.streetBlock);
        const streetStair = this.getFormattedValue(KEYS.streetStair);
        const streetPlant = this.getFormattedValue(KEYS.streetPlant);
        const streetletter = this.getFormattedValue(KEYS.streetletter);
        const postalCode = this.getFormattedValue(KEYS.postalCode);

        const addressOthersCompact = immEstate.get(KEYS.addressOthers) ? ` - ${immEstate.get(KEYS.addressOthers)}` : '';

        const provinceName = this.getFormattedValue(KEYS.provinceName);
        const populationName = this.getFormattedValue(KEYS.populationName);
        const population = populationName && provinceName ? `${populationName}, ` : `${populationName}`;

        const address = compact ? `${typeOfRoads} ${street}, ${streetNumber}` : `${typeOfRoads} ${street} ${streetNumber}`;
        const addressOthers = compact || !(streetBlock || streetStair || streetPlant || streetletter) ? addressOthersCompact : `${streetBlock}${streetStair}${streetPlant}${streetletter}`;
        const restOfAddress = ` (${postalCode} ${population} ${provinceName})`;

        return (
            <span className={className}>
                {address}{addressOthers}{restOfAddress}
            </span>
        );
    }
}

MortgageRequestFormattedAddress.propTypes = {
    immEstate: PropTypes.object.isRequired,
    className: PropTypes.string,
    compact: PropTypes.bool,
    v1: PropTypes.bool
};

MortgageRequestFormattedAddress.defualtProps = {
    compact: false,
    v1: false
};

module.exports = MortgageRequestFormattedAddress;